import React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import { FilterOptions } from "./types";

interface TicketFiltersProps {
  filters: FilterOptions;
  onFilterChange: (filterType: keyof FilterOptions, value: string | undefined) => void;
  size?: "sm" | "md" | "lg";
  showLabels?: boolean;
  direction?: "row" | "column";
}

const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "Open", label: "Open" },
  { value: "Closed", label: "Closed" },
];

const PRIORITY_OPTIONS = [
  { value: "", label: "All priorities" },
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent" },
];

export const TicketFilters: React.FC<TicketFiltersProps> = ({
  filters,
  onFilterChange,
  size = "sm",
  showLabels = true,
  direction = "column",
}) => {
  const containerStyle = {
    display: "flex",
    flexDirection: direction,
    gap: 2,
  };

  return (
    <div style={containerStyle}>
      <FormControl size={size}>
        {showLabels && <FormLabel>Status</FormLabel>}
        <Select
          placeholder="All statuses"
          value={filters.status || ""}
          onChange={(_, value) => onFilterChange("status", value as string)}
        >
          {STATUS_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </FormControl>

      <FormControl size={size}>
        {showLabels && <FormLabel>Priority</FormLabel>}
        <Select
          placeholder="All priorities"
          value={filters.priority || ""}
          onChange={(_, value) => onFilterChange("priority", value as string)}
        >
          {PRIORITY_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};